import { IProps } from '@/Interfaces/Icons/Props.interface';

const ExportPlaylistIcon = (props: IProps) => {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.8704 4.79629H11.9259V3.5H14.5185C14.8765 3.5 15.1667 3.79019 15.1667 4.14815V14.5185C15.1667 14.8765 14.8765 15.1667 14.5185 15.1667H4.14815C3.79019 15.1667 3.5 14.8765 3.5 14.5185V11.9259H4.79629V13.8704H13.8704V4.79629Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.833374 1.33301C0.833374 1.05687 1.05723 0.833008 1.33337 0.833008H12C12.2762 0.833008 12.5 1.05687 12.5 1.33301V11.9997C12.5 12.2758 12.2762 12.4997 12 12.4997H1.33337C1.05723 12.4997 0.833374 12.2758 0.833374 11.9997V1.33301ZM7.20797 3.51571C7.42851 3.45855 7.65977 3.55773 7.77044 3.7569C7.81317 3.83386 7.84471 3.92312 7.86531 3.98325C7.87857 4.02209 7.89457 4.07139 7.91017 4.11929L7.91051 4.12021C7.92004 4.14965 7.92951 4.17874 7.93824 4.20502C7.99011 4.36158 8.04844 4.52272 8.12464 4.66985C8.28077 4.97145 8.44491 5.09972 8.66671 5.09972H9.00004V6.09972H8.66671C8.32591 6.09972 8.05217 5.99647 7.83337 5.84413V7.99974C7.83337 9.01227 7.01257 9.83307 6.00004 9.83307C4.98752 9.83307 4.16671 9.01227 4.16671 7.99974C4.16671 6.98721 4.98752 6.16639 6.00004 6.16639C6.30011 6.16639 6.58335 6.23848 6.83337 6.36629V3.99972C6.83337 3.77188 6.98737 3.57286 7.20797 3.51571Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default ExportPlaylistIcon;
